var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4.5,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(90 10 4.5)",
    fill: "#000064"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHg9IjEwIiB5PSI0LjUiIHdpZHRoPSIyIiBoZWlnaHQ9IjEwIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTAgNC41KSIgZmlsbD0iIzAwMDA2NCIvPg0KPC9zdmc+DQo=";
export { SvgIconMinus as ReactComponent };